<template>
  <div>
    <div class="mian">
      <!-- 头部 -->
      <!-- <div class="top">
        <img src="../assets/images/头部框.png" alt="" />
        <div class="info">
          <span>企业信息</span>
        </div>
        <div class="num">
          <span>02</span>
        </div>
      </div> -->
      <div>
        <div class="goodsInfo goodsInfo2">
          <div class="goodsInfo-text">
            <div class="goods-title">企业全称</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.business_full_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">企业简称</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.business_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title w2">统—社会信用代码</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.credit_code }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title" style="width: 128px">地址</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.province }}{{ list2.city }}{{ list2.region
              }}{{ list2.addressdetail }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">联系电话</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.phone }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title w3">生产许可证编号</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.license_number }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title w1">区块链标识</div>
            <div class="goodsInfo-text-num texts" style="word-wrap: break-word">
              {{ list.txid }}
            </div>
          </div>
          <!-- <div class="goodsInfo-text">
            <div class="goods-title">执行标准</div>
            <div class="goodsInfo-text-num texts">
              {{ list2.executive_standard }}
            </div>
          </div> -->
        </div>
        <!-- <div class="goods-characteristic">
          <div class="goods-characteristic-inner">
            <span @click="toBlockChain"> 区块链标识：{{ list.txid }}</span>
          </div>
        </div> -->
      </div>
      <div class="b-material">
        <div class="material">
          <div class="dian">
            <div class="m-title">企业标识</div>
          </div>
          <div class="date">
            {{ list.ts | formant }}
          </div>
        </div>
        <div class="swipe-wrap" v-for="(item, index) in data" :key="index">
          <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(item, index) in data" :key="index" @click="switch_image(item.Value)">
                <img :src="item.Value" alt="" class="img" style="width: 100%; height: 100%;">
                
              </van-swipe-item>
             
            </van-swipe> -->
          <img
            :src="item.Value"
            alt=""
            @click="switch_image(item.Value)"
            class="img"
          />
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Overlay } from "vant";
import { ImagePreview } from "vant";
import Sertificate from "../components/Sertificate.vue";
Vue.use(Overlay);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  components: { Sertificate },
  props: {
    pyInfo: Object,
  },
  watch: {
    pyInfo(curVal, oldVal) {
      console.log(oldVal, "oldVal");
      if (curVal) {
        this.pyInfo = curVal;
        console.log(this.pyInfo, "pyInfo");

        this.list = this.pyInfo.data_list[0].msgItems[0];
        this.list2 = JSON.parse(this.pyInfo.data_list[0].msgItems[0].op.op);
        // this.picList = this.spObj.picList;
      }
    },
  },
  data() {
    return {
      listData: [],
      list: [],
      list2: {},
      data: [],
      pList: [],
      show: false,
      ts: "",
      txid: "",
    };
  },
  created() {
    // this.listData = JSON.parse(window.localStorage.getItem("defalutObj"));
    // this.list = this.listData.filter((item) => item.trace_name === "企业信息");
    // this.list.forEach((item) => {
    //   this.list = item.msgItems;
    // });
    this.data = JSON.parse(
      window.localStorage.getItem("corporateLogoImageList")
    );
    this.data.forEach((item) => {
      console.log("ttttt", item.Value);
    });
  },
  methods: {
    switch_image(img) {
      ImagePreview([img]);
    },
    toBlockChain() {
      this.show = true;
      this.ts = this.list.ts;
      this.txid = this.list.txid;
      // this.$router.push(`/Look?ts=${this.list.ts}&txid=${this.list.txid}`);
    },
    handleSwipeChange(v, type) {
      console.log(v, type);
      this.$refs[v][type]();
      // this.$nextTick(() => {
      //   this.$refs.swipe.next();
      //   console.log(this.$refs.swipe.next);
      //   this.$forceUpdate();
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.w1 {
  width: 400px !important;
}
.w2 {
  width: 240px !important;
}

.w3 {
  width: 200px !important;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mian {
  position: relative;
  width: 636px;
  margin-bottom: 20px;

  margin-top: 10px;
  background-color: #fff;
  .top {
    position: relative;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .product {
    width: 638px;
    height: 828px;
    background-color: skyblue;
    padding: 172px 0 30px 56px;
    border: #02b152 solid 10px;
    .text {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 45px;
      margin-top: -13vw;
      .text-top {
        color: #007d5f;
        font-weight: bold;
        line-height: 0px;
        opacity: 1;
        font-size: 32px;
        margin-bottom: 30px;
      }
      .text-bottom {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #000000;
        opacity: 1;
      }
    }
    .picture {
      width: 496px;
      height: 818px;
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 34px 60px 0 50px;
    }
  }
  .goodsInfo2 {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;

    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 636px;
    // height: 404px;
    border: 2px solid #f3f3f3;
    opacity: 1;
    margin: 0 auto;
    margin-top: 20px;
    padding: 25px;
    margin-bottom: 36px;
    .goodsInfo-text-num {
      white-space: pre-line;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .texts {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-left: 20px;
      color: #000000;
      opacity: 1;
    }
    .goodsInfo-text {
      .goods-title {
        width: 195px;
      }
      display: flex;
    }
  }
  .goods-characteristic {
    margin: 0 auto;
    width: 536px;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .b-material {
    .swipe-wrap {
      width: 546px;
      height: 280px;

      padding: 25px 0;
      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
      margin: 0 auto;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
    .material {
      display: flex;
      justify-content: space-between;
      width: 548px;
      height: 49px;

      align-items: center;
      margin: 0 auto;
      border-bottom: 2px solid #e8e8e8;
      .dian {
        .m-title {
          min-width: 112px;
          height: 40px;
          font-weight: 400;
          line-height: 0px;
          margin-left: 15px;
          margin-top: 5px;
        }
        width: 12px;
        height: 12px;
        background: #000000;
        border-radius: 50%;
        opacity: 1;
        margin-right: -330px;
        font-size: 28px;
      }
      .date {
        width: 250px;
        height: 28px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 28px;
        color: #919ab1;
        opacity: 1;
      }
    }
  }
}
</style>